<script>
import modelMixin from '../../mixins/modelMixin';

export default {
  name: 'w-statement',
  mixins: [modelMixin],
  props: {
    radioArrayName: {
      type: String,
      default: 'Fields'
    },
    radioValueName: {
      type: String,
      default: 'Value'
    }
  },
  data() {
    return {templateRender: () => {}};
  },
  render(h) {
    return this.templateRender();
  },
  created() {
    this.updateRender(this.model);
  },
  methods: {
    replaceText(value, regex) {
      let newValue = '';
      const allSplited = value.split(regex);
      const onlySimpleText = value.replace(regex, '###').split('###');

      const radioArrayName = this.radioArrayName;
      const radioValueName = this.radioValueName;

      allSplited.forEach(elem => {
        let radioIndex = 0;
        if (elem) {
          if (onlySimpleText.includes(elem)) {
            newValue += elem;
          } else {
            const values = elem.split('/').map((item, index) => ({
              value: index + 1,
              text: item
            }));
            const modelPath = `:model="model.${radioArrayName}.$items[${radioIndex}].$item.${radioValueName}"`;
            values.forEach(val => {
              newValue += /*html*/ `<w-radio ${modelPath} :value="${val.value}" :inline="true" :show-error="false" class="statement-radio">${val.text}</w-radio>&nbsp;`;
            });
            newValue += /*html*/ `
            <w-error ${modelPath} style="display: inline"/>`;
            radioIndex++;
          }
        }
      });

      return '<span>' + (newValue || '') + '</span>';
    },
    updateRender(value) {
      let Vue = this.constructor;
      while (Vue.super) {
        Vue = Vue.super;
      }
      const replacedText = this.replaceText(this.model.Tresc.$value, /\[([^\]^\d]+)\]/gi);
      const compiled = Vue.compile(replacedText);
      this.templateRender = compiled.render;
      this.$options.staticRenderFns = [];
      for (const staticRenderFunction of compiled.staticRenderFns) {
        this.$options.staticRenderFns.push(staticRenderFunction);
      }
    }
  }
};
</script>

<style>
.statement-radio > label.radio.radio-inline {
  margin-bottom: 3px !important;
}
</style>